export const COMMUNITY_UNDEFINED = 0;
export const COMMUNITY_DRAFT = 1;
export const COMMUNITY_ACTIVE = 2;
export const COMMUNITY_ARCHIVED = 3;
